var _rect, _line, _line2, _line3, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorSmokingArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.824,
    y: 32.195,
    width: 36.351,
    height: 5.481
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 36.508,
    y1: 32.195,
    x2: 36.508,
    y2: 37.676
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33.902,
    y1: 32.195,
    x2: 33.902,
    y2: 37.676
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12.4,
    y1: 32.195,
    x2: 12.4,
    y2: 37.676
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.395,4.324c2.088,0,3.781,1.693,3.781,3.781v.154c0,2.088-1.693,3.781-3.781,3.781h0c-2.088,0-3.781,1.693-3.781,3.781v.045c0,2.088,1.693,3.781,3.781,3.781h0c2.088,0,3.781,1.693,3.781,3.781v3.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m27.833,4.324c2.088,0,3.781,1.693,3.781,3.781v.154c0,2.088-1.693,3.781-3.781,3.781h0c-2.088,0-3.781,1.693-3.781,3.781v.045c0,2.088,1.693,3.781,3.781,3.781h0c2.088,0,3.781,1.693,3.781,3.781v3.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorSmokingArea);
export default __webpack_public_path__ + "static/media/indoor-smoking_area.96d2ad61c374c507e77aefc3455fcb75.svg";
export { ForwardRef as ReactComponent };